import React, { FC } from 'react'

import { IconButton, styled } from '@mui/material'

const RootContainer = styled('div')(() => ({

}))

const TitleContainer = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
}))

const Title = styled('h2')(() => ({
    color: '#263238',
    fontSize: 14,
    lineHeight: '24px',
    fontWeight: 500,
    fontFamily: 'Poppins',
}))

const EditIconButton = styled(IconButton)(() => ({
    color: 'black'
}))

export interface GroupContainerTitleProps {
    label: string
    onChange?: (newLabel: string) => void
}

const GroupConditionTitle: FC<GroupContainerTitleProps> = (props) => {
    return (
        <RootContainer>
            <TitleContainer>
                <Title>{props.label}</Title>
            </TitleContainer>
        </RootContainer>
    )
}

export default GroupConditionTitle